<mat-card style="padding: 0.5in;">
  <!-- <mat-card-header> -->

  <div class="row" style="margin-bottom: 20px;">
    <div class="col-sm-6" style="text-align: left;">
      <button mat-raised-button (click)="closeDialog()">
        <mat-icon>close</mat-icon>
        Close
      </button>
    </div>
    <div class="col-sm-6" style="text-align: right;">
      <button mat-raised-button color="primary" (click)="printReport()">
        <mat-icon>print</mat-icon>
        Print Report
      </button>
    </div>
  </div>

  <!-- </mat-card-header> -->
  <mat-card-content>

    <kendo-pdf-export #pdf paperSize="letter" [scale]="0.6" margin="0.25in">

      <div>

        <div class="row">
          <div class="col-sm-8">
            <span style="font-size:larger"><strong>ORELAP Fields of Accreditation Summary</strong></span>
          </div>
          <div class="col-sm-2">
            <span class="pull-left" style="font-size:larger">ORELAP ID</span>
          </div>
          <div class="col-sm-2">
            <span class="pull-right" style="font-size:larger"><strong>{{orelapId}}</strong></span>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-8"></div>
          <div class="col-sm-2">
            <span class="pull-left" style="font-size:larger">EPA CODE</span>
          </div>
          <div class="col-sm-2">
            <span class="pull-right" style="font-size:larger"><strong>{{epaId}}</strong></span>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-8"></div>
          <div class="col-sm-2">
            <span class="pull-left" style="font-size:larger">APP ID</span>
          </div>
          <div class="col-sm-2">
            <span class="pull-right" style="font-size:larger"><strong>{{appId}}</strong></span>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <table class="table table-condensed pdf-table">
              <colgroup>
                <col style="width: 8%" />
                <col style="width: 8%" />
                <col style="width: 12%" />
                <col style="width: 22%" />
                <col style="width: 18%" />
                <col style="width: 10%" />
                <col style="width: 10%" />
                <col style="width: 12%" />
              </colgroup>
              <thead>
                <tr class="matrix-row">
                  <th style="border-top: none">Matrix</th>
                  <th style="border-top: none">Method</th>
                  <th style="border-top: none">Analyte Code</th>
                  <th style="border-top: none">Analyte</th>
                  <th style="border-top: none">Category</th>
                  <th style="border-top: none">New Status</th>
                  <th style="border-top: none">Current Status</th>
                  <th style="border-top: none">Date Accredited</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let matrix of groupedTechnologies">
                  <tr class="matrix-row">
                    <td colspan="8" style="font-size: x-large;"><strong>{{matrix.matrix}}</strong></td>
                  </tr>

                  <ng-container *ngFor="let method of matrix.foaList">
                    <tr>
                      <td style="border-top: none"></td>
                      <td style="background-color: #b5b3b3; border-top: none">
                        <strong>{{method.method}}</strong>
                      </td>
                      <td colspan="2" style="background-color: #b5b3b3; border-top: none">
                        <strong>{{method.foas[0].methodReference}}</strong>
                      </td>
                      <!-- <td style="background-color: #b5b3b3; border-top: none"></td> -->
                      <td colspan="4" style="background-color: #b5b3b3; border-top: none">
                        <strong>{{method.foas[0].methodTitle}}</strong>
                      </td>
                      <!-- <td style="background-color: #b5b3b3; border-top: none " colspan="3"></td> -->
                    </tr>
                    <tr *ngFor="let foa of method.foas">
                      <td style="border-top: none"></td>
                      <td style="background-color: #b5b3b3; border-top: none"></td>
                      <td class="matrix-row" style="border-top: none">{{foa.analyteCode}}</td>
                      <td class="matrix-row" style="border-top: none">{{foa.analyte}}</td>
                      <td class="matrix-row" style="border-top: none">{{foa.category}}</td>
                      <td class="matrix-row" style="border-top: none">{{foa.newStatus}}</td>
                      <td class="matrix-row" style="border-top: none">{{foa.currentStatus}}</td>
                      <td class="matrix-row" style="border-top: none">{{foa.currentStatusDate | date:'shortDate'}}</td>
                    </tr>
                  </ng-container>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </kendo-pdf-export>
  </mat-card-content>
</mat-card>